import { composeIO } from 'react-compose-io'
import { graficoDonutClassificacoesIO } from './GraficoDonutClassificacoes.IO'
import { GraficoDonutClassificacoesView } from './GraficoDonutClassificacoes.View'

export const GraficoDonutClassificacoes = composeIO(GraficoDonutClassificacoesView, graficoDonutClassificacoesIO)
